import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { mergeMap, Observable } from "rxjs";
import { ConfigService } from "../../../config/config.service";
import { AuthenticationService } from "../authentication/authentication.service";

@Injectable({
  providedIn: "root"
})
export class AuthorizationService {
  roles: Array<string> = new Array<string>();
  constructor(private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private http: HttpClient
  ) {
    this.authenticationService.currentUser$.subscribe(user => {
      if (user.isLoggedIn()) {
        this.roles = user.roles;
      } else {
        this.roles = new Array<string>();
      }
    });
  }
  hasPermission(role: string | Array<string>): boolean {
    if (role instanceof Array) {
      return role.filter(ele => {
        return this.hasPermission(ele);
      }).length != 0;
    } else {
      return this.roles.includes(role);
    }
  }
  hasRoleClnt(): boolean {
    for (let role of this.roles) {
      if (role.match(/_CLNT$/)) {
        return true;
      }
    }
  }

  public inMaintenance(): Observable<boolean> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<boolean>(config.apiPoint + config.getMaintenance, { withCredentials: false });
      })
    );
  }
}
